import web from "../web";

class CoursService {
    index(token){
        return web.get("/api/cours", { headers: {'Authorization': 'Bearer '+token  } })
    }

    liste(token){
        return web.get("/api/cours/liste", { headers: {'Authorization': 'Bearer '+token  } })
    }

    store(data, token){
        return web.post("api/cours", data,{ headers: {'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/cours/${id}/show`,{ headers: {'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/cours/update", data,{ headers: {'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/cours/${id}/delete`,{ headers: {'Authorization': 'Bearer '+token } })
    }

    index_jours(token){
        return web.get("/api/jours", { headers: {'Authorization': 'Bearer '+token  } })
    }

    getCoursByEnseignants(id,token){
        return web.get(`/api/cours/enseignants/${id}`, { headers: {'Authorization': 'Bearer '+token  } })
    }

    getCoursByClassesoptions(id,token){
        return web.get(`/api/cours/classesoptions/${id}`, { headers: {'Authorization': 'Bearer '+token  } })
    }
}

export default new CoursService()